import { Component } from 'preact';
import { Link } from 'preact-router';
// import { resetMap } from '../lib/worldmap';
import { currentPath } from '../lib/utils';
import { resetMap } from '../lib/worldmap';

export default class Header extends Component {
  render (props) {
    const { countryId, year } = currentPath();
    const resetUrl = countryId ? `/${year || ''}` : '/';

    // reset map on home; reset year if no countryId and map already reset

    return <header class="h-card">
      <div class="org">
        <a class="logo u-url" href="https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project" target="_blank">
          <img class="u-logo p-name p-org" alt="Anglia Ruskin University" src="/assets/aru-logo.svg" />
        </a>

        <svg class="division">
          <line x1="0" y1="0" x2="0" y2="100%" />
        </svg>

        <a class="faculty p-organization-unit" href="https://www.anglia.ac.uk/global-sustainability-institute-gsi" target="_blank">Global Sustainability Institute</a>
      </div>
      
      <h1>
        <Link class="project-name" href={ resetUrl } onClick={ !countryId && resetMap }>
        Chaos Map
        </Link>
      </h1>
    </header>
  }
}



// WEBPACK FOOTER //
// ./components/Header.js